/* Cart policy shared by the storefront controller and its quantity/pairing tests. */
(function (root) {
  'use strict';
  var detailKeys = ['Mounting details', 'Boot sole length (mm)', 'Mount preference', 'Final shop adjustment'];
  function clearDetails(properties) {
    detailKeys.concat(['Weight', 'Age', 'Skier type']).forEach(function (key) { delete properties[key]; });
  }
  function copy(item) { return Object.assign({}, item, { properties: Object.assign({}, item.properties) }); }
  function details(properties) {
    var result = {};
    detailKeys.forEach(function (key) { if (properties[key]) result[key] = properties[key]; });
    return result;
  }
  function detach(item) {
    delete item.properties._4frnt_pair;
    delete item.properties._4frnt_offer;
    item.properties._4frnt_pair_choice = 'review';
    clearDetails(item.properties);
    delete item.properties._4frnt_mounting_hold;
  }
  function choosePair(items, skiUnit, bindingUnit, makeId) {
    var lines = items.map(copy);
    var ski = lines.find(function (item) { return item.kind === 'ski' && item.properties._4frnt_unit === skiUnit; });
    var binding = lines.find(function (item) { return item.kind === 'binding' && item.properties._4frnt_unit === bindingUnit; });
    if (!ski) throw new Error('The ski is no longer in your cart.');
    var intake = details(ski.properties);
    var oldPairs = [ski.properties._4frnt_pair, binding && binding.properties._4frnt_pair].filter(Boolean);
    lines.forEach(function (item) {
      if ((item.kind === 'ski' || item.kind === 'binding') && oldPairs.indexOf(item.properties._4frnt_pair) !== -1) detach(item);
    });
    ski.properties._4frnt_pair_choice = 'manual';
    Object.assign(ski.properties, intake);
    if (binding) {
      var pair = makeId();
      ski.properties._4frnt_pair = pair;
      binding.properties._4frnt_pair = pair;
    }
    return lines;
  }
  function plan(items, options) {
    var makeId = options.makeId;
    var lines = [];
    var unitIds = new Set();
    var mounts = items.filter(function (item) { return item.kind === 'mount' && item.properties._4frnt_offer === 'mount'; });
    items.forEach(function (item) {
      if (mounts.indexOf(item) !== -1) return;
      if (item.kind !== 'ski' && item.kind !== 'binding') { lines.push(item); return; }
      for (var index = 0; index < item.quantity; index++) {
        var unit = copy(item);
        unit.quantity = 1;
        unit.sourceKey = index === 0 ? item.key : null;
        unit.splitSourceKey = index ? item.key : null;
        var duplicateUnit = unit.properties._4frnt_unit && unitIds.has(unit.properties._4frnt_unit);
        if (index || duplicateUnit || !unit.properties._4frnt_unit) unit.properties._4frnt_unit = makeId();
        unitIds.add(unit.properties._4frnt_unit);
        if (index || duplicateUnit) {
          detach(unit);
          delete unit.properties._4frnt_mounting;
        }
        lines.push(unit);
      }
    });
    var skis = lines.filter(function (item) { return item.kind === 'ski'; });
    var bindings = lines.filter(function (item) { return item.kind === 'binding'; });
    var pairIds = Array.from(new Set(skis.map(function (item) { return item.properties._4frnt_pair; }).filter(Boolean)));
    var pairs = [];
    pairIds.forEach(function (id) {
      var pairSkis = skis.filter(function (item) { return item.properties._4frnt_pair === id; });
      var pairBindings = bindings.filter(function (item) { return item.properties._4frnt_pair === id; });
      if (pairSkis.length === 1 && pairBindings.length === 1) pairs.push({ id: id, ski: pairSkis[0], binding: pairBindings[0] });
    });
    lines.forEach(function (item) {
      if (item.kind !== 'ski' && item.kind !== 'binding') return;
      if (item.properties._4frnt_pair && !pairs.some(function (pair) { return pair.id === item.properties._4frnt_pair; })) detach(item);
      delete item.properties._4frnt_offer;
    });
    // Only a cart with exactly one of each has an unambiguous automatic choice.
    if (!pairs.length && skis.length === 1 && bindings.length === 1 && !skis[0].properties._4frnt_pair_choice) {
      var id = makeId();
      skis[0].properties._4frnt_pair = id;
      bindings[0].properties._4frnt_pair = id;
      pairs.push({ id: id, ski: skis[0], binding: bindings[0] });
    }
    pairs.forEach(function (pair) {
      pair.ski.properties._4frnt_offer = 'paired-ski';
      pair.binding.properties._4frnt_offer = 'paired-binding';
      if ((options.removedMounts || []).indexOf(pair.id) !== -1) pair.ski.properties._4frnt_mounting = 'removed';
      if (pair.ski.properties._4frnt_mounting === 'removed') {
        [pair.ski, pair.binding].forEach(function (item) {
          clearDetails(item.properties);
          delete item.properties._4frnt_mounting_hold;
        });
        return;
      }
      var existing = mounts.find(function (item) { return item.properties._4frnt_pair === pair.id; });
      var intake = Object.assign({ 'Mounting details': 'Provide later' }, details(pair.ski.properties), existing && details(existing.properties));
      [pair.ski, pair.binding].forEach(function (item) {
        clearDetails(item.properties);
        Object.assign(item.properties, intake, { _4frnt_mounting_hold: 'shop-review' });
      });
      if (!options.mountingVariant) return;
      var mount = existing ? copy(existing) : { kind: 'mount', variant_id: options.mountingVariant, properties: {}, title: 'Ski mounting' };
      mount.sourceKey = existing && existing.key;
      mount.quantity = 1;
      clearDetails(mount.properties);
      Object.assign(mount.properties, intake, {
        _4frnt_pair: pair.id, _4frnt_offer: 'mount', _4frnt_mounting_hold: 'shop-review',
        'Ski': pair.ski.title, 'Binding': pair.binding.title,
      });
      pair.mount = mount;
      lines.push(mount);
    });
    var unpairedSkis = skis.filter(function (item) { return !item.properties._4frnt_pair; });
    var unpairedBindings = bindings.filter(function (item) { return !item.properties._4frnt_pair; });
    return { lines: lines, pairs: pairs, skis: skis, bindings: bindings, needsPairing: unpairedSkis.some(function (item) { return item.properties._4frnt_pair_choice !== 'manual'; }) && unpairedBindings.length > 0 };
  }
  var api = { plan: plan, choosePair: choosePair, clearDetails: clearDetails };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.FourfrntMountingModel = api;
})(typeof window !== 'undefined' ? window : globalThis);
